import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { EmptyState } from '@xing-com/empty-state';
import { SingleSizeIllustrationErrorPage500 } from '@xing-com/illustrations';
import { xdlColorBorderStrong } from '@xing-com/tokens';

import { PromptErrorIllustration as PromptErrorIllustrationComponent } from '../assets/prompt-error-illustration';
import { ErrorType } from '../hooks/use-fabi-ai-generation';
import { useTrackingSwimp } from '../tracking';

type ErrorScreenProps = {
  errorType: ErrorType;
  refetchGetPrompt: () => void;
  backToInput: () => void;
};

export const ErrorScreen: React.FC<ErrorScreenProps> = ({
  errorType,
  refetchGetPrompt,
  backToInput,
}) => {
  const { formatMessage } = useIntl();
  const { trackError, trackRetry } = useTrackingSwimp();

  useEffect(() => {
    trackError(errorType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const emptyStateProps = {
    [ErrorType.System]: {
      illustration: SingleSizeIllustrationErrorPage500,
      buttonProps: {
        onClick: () => {
          trackRetry(ErrorType.System);
          refetchGetPrompt();
        },
      },
      headlineText: formatMessage({ id: 'COMMUNICATION_ERROR_500_TITLE' }),
      bodyCopyText: formatMessage({ id: 'COMMUNICATION_ERROR_500_SUBLINE' }),
      buttonText: formatMessage({ id: 'LOSP_SWIMP_ERROR_BUTTON_SYSTEM' }),
    },
    [ErrorType.Prompt]: {
      illustration: PromptErrorIllustration,
      buttonProps: {
        onClick: () => {
          trackRetry(ErrorType.Prompt);
          backToInput();
        },
      },
      headlineText: formatMessage({ id: 'LOSP_SWIMP_ERROR_TITLE_PROMPT' }),
      bodyCopyText: formatMessage({ id: 'LOSP_SWIMP_ERROR_TEXT_PROMPT' }),
      buttonText: formatMessage({ id: 'LOSP_SWIMP_ERROR_BUTTON_PROMPT' }),
    },
  };

  return (
    <div>
      <EmptyState
        illustrationProps={{ width: 180, height: 180 }}
        variant="engage"
        {...emptyStateProps[errorType]}
      />
    </div>
  );
};

const PromptErrorIllustration = styled(PromptErrorIllustrationComponent)`
  .chaosPath {
    stroke: ${xdlColorBorderStrong};
  }
`;
